"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAssignments = (assignments) => {
    const mappedAssignments = {};
    for (let assignment of assignments) {
        mappedAssignments[assignment.location.id] = 'current';
        for (let assignmentParent of assignment.parents) {
            mappedAssignments[assignmentParent.id] = 'parent';
        }
    }
    return mappedAssignments;
};
exports.mapOtherServiceAssignments = (assignments) => {
    const mapped = {};
    for (let assignment of assignments) {
        mapped[assignment.location.id] = assignment.server;
    }
    return mapped;
};
exports.getStatesForAssignments = (assignments, locations) => {
    const mappedAssignments = exports.mapAssignments(assignments);
    return locations.reduce((accum, layout) => {
        const currentOrParent = mappedAssignments[layout.id];
        const state = currentOrParent === 'parent' ? 'partial' : currentOrParent === 'current' ? 'selected' : 'unselected';
        accum[layout.id] = state;
        return accum;
    }, {});
};
exports.selectedToState = (selected) => {
    return selected.reduce((accum, layout) => {
        accum[layout.location.id] = 'selected';
        return accum;
    }, {});
};
exports.findLocationsToAddAndRemove = (original, current) => {
    const mappedCurrentAssignments = exports.mapAssignments(current);
    const mappedOriginalAssignments = exports.mapAssignments(original);
    const locationIdsToAdd = current
        .filter(assignment => {
        return mappedOriginalAssignments[assignment.location.id] !== 'current';
    })
        .map(assignment => assignment.location.id);
    const locationIdsToRemove = original
        .filter(assignment => {
        return mappedCurrentAssignments[assignment.location.id] !== 'current';
    })
        .map(assignment => assignment.location.id);
    return {
        locationIdsToAdd,
        locationIdsToRemove,
    };
};
exports.transformAssignmentResponse = (response) => {
    const combinedByParentMap = response.reduce((accum, row) => {
        if (row.parents.length === 0) {
            return accum;
        }
        const compoundKey = row.parents
            .map(parent => {
            return parent.id;
        })
            .join('-');
        accum[compoundKey] = accum[compoundKey] || { id: compoundKey, parents: row.parents, locations: [] };
        accum[compoundKey].locations.push(row.location);
        return accum;
    }, {});
    const noParents = response.filter(assignment => {
        return assignment.parents.length === 0;
    }).reduce((accum, assignment) => {
        accum.id += `-${assignment.location.id}`;
        accum.locations.push(assignment.location);
        return accum;
    }, {
        id: '',
        parents: [],
        locations: [],
    });
    const byParent = Object.values(combinedByParentMap).concat(noParents);
    return byParent.map((row) => {
        return {
            id: row.id,
            parentNames: row.parents.map(parent => parent.name),
            locations: row.locations,
        };
    });
};
//# sourceMappingURL=index.js.map